export default __webpack_public_path__ + "static/media/Size5D.143a2860.png";